module.exports = __webpack_public_path__ + "static/img/situation_1.cf8ac18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/situation_1.jpg
// module id = DvBT
// module chunks = 1